import { useCreateAccount } from '../../../../hooks';
import { ESP_ACCOUNT_PAYLOAD_FIELDS } from '../../../../types';
import { ConnectedInputField } from '../../Shared/ConnectedInputField';
import { CreateModalRHF } from '../../Shared/CreateModalRHF';

const { API_KEY, NAME } = ESP_ACCOUNT_PAYLOAD_FIELDS;

export const TEXT = {
  HEADER: 'Connect Sendgrid account',
  CONFIRM_BUTTON: 'Connect',
};

export const SendgridCreateModal = () => {
  const { createAccount } = useCreateAccount();

  return (
    <CreateModalRHF onSubmit={createAccount} headerText="Connect Sendgrid account">
      <ConnectedInputField name={NAME} labelText="Name" data-test="name-input" />
      <ConnectedInputField name={API_KEY} labelText="API key" data-test="apiKey-input" />
    </CreateModalRHF>
  );
};
